const REG_EXP = /url\(["']?([^'"]+)["']?\)[;\s]*/;

export function extract(cssRule) {
    let keyVal = cssRule.split(':');
    let val = keyVal[1];

    if (!val && REG_EXP.test(cssRule)) {
        val = cssRule;
    }

    if (val) {
        let matches = val.trim().match(REG_EXP);

        if (matches && matches[1]) {
            let url = matches[1];

            return url.trim().replace(/^"(.+)"$/, '$1');
        }
    }

    return cssRule;
}



// WEBPACK FOOTER //
// ./js/main/package/extract-css-url.js